interface FormVideos {
    id: number;
  link: string;
}

export const formsVideo: FormVideos [] = [
    {
        id: 12,
        link: 'https://youtube.com/embed/Vn6IFebJChs'
    },
    {
        id: 11,
        link: 'https://youtube.com/embed/S3FmuNDU2hw'
    },
    {
        id: 10,
        link: 'https://youtube.com/embed/L5znm4uvYI8'
    },
    {
        id: 9,
        link: 'https://youtube.com/embed/yQu5hnJNGJw'
    },
    {
        id: 8,
        link: 'https://youtube.com/embed/l75MGmZo1G0'
    },
    {
        id: 7,
        link: 'https://youtube.com/embed/EgAIlkeQaFo'
    },
    {
        id: 6,
        link: 'https://youtube.com/embed/zBmQbMBxNs8'
    },
    {
        id: 5,
        link: 'https://youtube.com/embed/PRVOvYVrXfc'
    },
    {
        id: 4,
        link: 'https://youtube.com/embed/AtDuBdqwqOw'
    },
    {
        id: 3,
        link: 'https://youtube.com/embed/2pU6I1v1oQs'
    },
    {
        id: 2,
        link: 'https://youtube.com/embed/sP4XkJ4n-bA'
    },
    {
        id: 1,
        link: 'https://youtube.com/embed/tcDc5ky2iyw'
    },
    {
        id: 0,
        link: 'https://youtube.com/embed/40MxZQMk8io'
    }
];